<template>
  <div class="fee-input" :class="{ inline }">
    <el-input size="mini" placeholder="请输入" :value="value" @input="input" />
    <div class="fee-text">{{ title }}：{{ feeText }} 万元</div>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';

export default {
  props: {
    value: [String, Number],
    title: {
      type: String,
      default: () => '费用'
    },
    fee: Number,
    inline: {
      type: Boolean,
      default: true
    }
  },
  watch: {},
  computed: {
    feeText() {
      if (isNil(this.fee) || window.isNaN(this.fee)) {
        return '--';
      }
      if (typeof this.fee === 'number') {
        if (this.fee.toString().indexOf('.') !== -1) {
          return this.fee.toFixed(2);
        }
      }
      return this.fee;
    }
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="less" scoped>
.fee-input {
  &.inline {
    display: flex;
  }

  /deep/.el-input {
    width: 300px;
  }

  .fee-text {
    padding-left: 8px;
    color: #666;
    font-size: 12px;
  }
}
</style>
